import { db } from "../../services/firebase/Config";
import { SET_EMPRESA } from "./empresaTypes";
import {
  setUser,
  httpUserRequest,
  httpUserRequestSuccess,
} from "../usuario/usuarioActions";
import {
  httpRequest,
  httpSuccess,
  httpFailure,
  setUsuarioSesion,
} from "../sesion/sesionActions";
import {
  getEmpresaById,
  saveEmpresa,
  addEmpresa,
} from "../../services/firebase/empresas/index";


let accesos = require("../../data/accesos.json");



export const setEmpresa = (empresa) => {
  return {
    type: SET_EMPRESA,
    payload: empresa,
  };
};

export const getEmpresa = (empresaId) => {
  return function (dispatch) {
    dispatch(httpRequest());
    getEmpresaById(empresaId)
      .then((empresa) => {

        dispatch(setEmpresa(empresa));
        dispatch(httpSuccess());
      })
      .catch((err) => {
        dispatch(httpFailure(err));
      });
  };
};

export const guardaEmpresa = (empresa) => {
  return function (dispatch) {
    dispatch(httpRequest());
    saveEmpresa(empresa)
      .then((emp) => {
        dispatch(setEmpresa(empresa));
        dispatch(httpSuccess());
      })
      .catch((err) => dispatch(httpFailure(err)));
  };
};

export const agregaEmpresa = (empresa) => {
  return function (dispatch) {
    dispatch(httpRequest());
    addEmpresa(empresa)
      .then((emp) => {
        dispatch(setEmpresa(emp));
        dispatch(httpSuccess());
      })
      .catch((err) => dispatch(httpFailure(err)));
  };
};

export const guardaEmpresaUsuario = (empresa, usuario) => {
  return async function (dispatch) {
    dispatch(httpUserRequest());
    var batch = db.batch();

    const empresasRef = db.collection("empresas").doc();
    // FIX: Guardar usuario dentro de la colección de la empresa para consistencia
    const usuariosRef = empresasRef.collection("usuarios").doc();
    const rootUsuariosRef = db.collection("usuarios").doc(usuariosRef.id);
    const secuenciasRef = empresasRef.collection("secuencias").doc();
    const fecha = new Date();
    let newSequence = {
      year: fecha.getFullYear(),
      empresaId: empresasRef.id,
      nombre: "orden",
      valor: 0,
    };
    let fecVen = fecha.setDate(fecha.getDate() + 30);
    fecVen = new Date(fecVen);

    dispatch(httpRequest());
    usuario.empresaId = empresasRef.id;
    usuario.cargo = "GERENTE";
    usuario.perfil = "ODONTOLOGO_ADM";
    usuario.id = usuariosRef.id;
    usuario.fecha = fecha;

    empresa.id = empresasRef.id;
    empresa.fecIni = fecha;
    empresa.fecUltPago = fecha;

    const resolvedPlan = (empresa.tipoMembresia || "basic").toLowerCase();

    let planData = {};
    try {
      const planDoc = await db
        .collection("configuraciones_generales")
        .doc("planes")
        .collection("items")
        .doc(resolvedPlan)
        .get();
      
      if (planDoc.exists) {
        planData = planDoc.data();
      } else {
        const planesSnapshot = await db
          .collection("configuraciones_generales")
          .doc("planes")
          .collection("items")
          .get();
        planesSnapshot.forEach((doc) => {
          if (doc.id.toLowerCase() === resolvedPlan || doc.data().nombre?.toLowerCase() === resolvedPlan) {
            planData = doc.data();
          }
        });
      }
    } catch (error) {
      console.error("Error al obtener detalles del plan:", error);
    }
    
    // Configurar trial dinámico a partir del plan
    let trialDays = 7;
    if (planData && planData.trial && planData.trial.durationDays !== undefined) {
      const days = parseInt(planData.trial.durationDays, 10);
      if (!isNaN(days)) {
        trialDays = days;
      }
    }
    
    const trialStart = new Date();
    const trialEnd = new Date(trialStart.getTime() + trialDays * 24 * 60 * 60 * 1000);
    
    // Regla 8: Guardar los nuevos campos en el modelo
    empresa.plan = resolvedPlan;
    empresa.subscription = {
      status: "trial",
      trialStart: trialStart,
      trialEnd: trialEnd
    };
    empresa.usage = {
      whatsappMessagesSent: 0
    };

    // Para compatibilidad
    empresa.fecVen = trialEnd;
    empresa.tipoMembresia = resolvedPlan.toUpperCase();
    empresa.estado = "ACTIVO";

    const planDetails = {
      plan: resolvedPlan.toUpperCase(),
      usuarios: planData.limiteUsuarios || planData.usuarios || 1,
      pacientes: planData.limitePacientes || planData.pacientes || 3,
      prestaciones: planData.limitePrestaciones || planData.prestaciones || 5,
      perfiles: planData.perfiles || (resolvedPlan.toUpperCase() === 'GOLD' ? ['ODONTOLOGO', 'ODONTOLOGO', 'ASISTENTE', 'ADMINISTRADOR'] : (resolvedPlan.toUpperCase() === 'SILVER' ? ['ODONTOLOGO_ADM', 'ASISTENTE'] : ['ODONTOLOGO_ADM'])),
      maxMensajesWhatsapp: planData.maxMensajesWhatsapp || 10
    };
    empresa.membresia = planDetails;
    console.log('empresa.membresia:', empresa.membresia);


    batch.set(empresasRef, empresa);
    batch.set(usuariosRef, usuario);
    batch.set(rootUsuariosRef, usuario);
    batch.set(secuenciasRef, newSequence);



    return batch
      .commit()
      .then(() => {
        dispatch(setEmpresa(empresa));
        dispatch(setUsuarioSesion(usuario));
        dispatch(httpUserRequestSuccess(usuario));
        //dispatch(setUser(usuario));
        dispatch(httpSuccess());
        return { empresa, usuario };
      })
      .catch((err) => {
        dispatch(httpFailure(err));
        throw err;
      });
  };
};
